import React from "react";
import { Button, Badge } from "@material-ui/core";
import { I18n } from "react-redux-i18n";
import { Checkbox, Dialog, FormControl, InputLabel, ListItemText, MenuItem, Select, TextField } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import PropTypes from 'prop-types';
import { find, map, includes, join, flatMap, get, uniq } from "lodash";
import './css/onDemandFilter.css';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
const INCABIN_CHANNEL = {id: 3, 'channel': 2, 'name': 'page.onDemand.previouslyQueue.cameraViews.incabin'};
const initialState = {
  open: false,
  showInCabinCamera: false,
  defaultCameraViewValue: [
    {id: 1, 'channel': 1, 'name': 'page.onDemand.previouslyQueue.cameraViews.forwardFacing'},
    {id: 2, 'channel': 2, 'name': 'page.onDemand.previouslyQueue.cameraViews.passenger'},
    {id: 4, 'channel': 3, 'name': 'page.onDemand.previouslyQueue.cameraViews.rear'},
    {id: 5, 'channel': 4, 'name': 'page.onDemand.previouslyQueue.cameraViews.driver'},
  ],
  defaultStatusValue: [
    {'id': 'requested', 'name': 'page.onDemand.previouslyQueue.statuses.requested'},
    {'id': 'processed', 'name': 'page.onDemand.previouslyQueue.statuses.processed'},
    {'id': 'completed', 'name': 'page.onDemand.previouslyQueue.statuses.completed'},
    {'id': 'cancelled', 'name': 'page.onDemand.previouslyQueue.statuses.cancelled'},
    {'id': 'expired', 'name': 'page.onDemand.previouslyQueue.statuses.expired'},
    {'id': 'notavailable', 'name': 'page.onDemand.previouslyQueue.statuses.notavailable'},
    {'id': 'failed', 'name': 'page.onDemand.previouslyQueue.statuses.failed'}
  ]
};

export default class DesktopOnDemandFilter extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onDemandFilter: PropTypes.shape({
      vehicleValue: PropTypes.string.isRequired,
      whoRequestedValue: PropTypes.string.isRequired,
      cameraViewValue: PropTypes.array.isRequired,
      statusValue: PropTypes.array.isRequired,
    }),
    tabIndex: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);
    const {vehicleValue, whoRequestedValue, statusValue, cameraViewValue} = props.onDemandFilter;

    this.state = {
      vehicleValue,
      whoRequestedValue,
      cameraViewValue: cameraViewValue || [],
      statusValue: statusValue || [],
      localVehicleValue: vehicleValue,
      localWhoRequestedValue: whoRequestedValue,
      localCameraViewValue: cameraViewValue || [],
      localStatusValue: statusValue || [],
      tabIndex: props.tabIndex,
      showInCabinCamera: props.showInCabinCamera,
      ...initialState
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.tabIndex !== prevState.tabIndex) {
      this.setState({
        vehicleValue: "",
        whoRequestedValue: "",
        cameraViewValue: [],
        statusValue: [],
        localVehicleValue: "",
        localWhoRequestedValue: "",
        localCameraViewValue: [],
        localStatusValue: [],
        tabIndex: prevProps.tabIndex,
        showInCabinCamera: this.props.showInCabinCamera
      });
    }
    const defaultViews = [...this.state.defaultCameraViewValue];
    if(prevProps.showInCabinCamera !== this.props.showInCabinCamera){
      if(this.props.showInCabinCamera === 'true'){
        const channel_item = this.state.defaultCameraViewValue.find((ch) => ch.id == "2");
        if(channel_item){
          channel_item.name = "page.onDemand.previouslyQueue.cameraViews.passengerorincabin";
        }
      }
      this.setState({defaultCameraViewValue: defaultViews});
    }
  }

  handleClear = () => {
    this.setState({
      vehicleValue: "",
      whoRequestedValue: "",
      cameraViewValue: [],
      statusValue: [],
      localVehicleValue: "",
      localWhoRequestedValue: "",
      localCameraViewValue: [],
      localStatusValue: [],
      open: false
    }, () => {
      this.props.onChange({
        vehicle: this.state.vehicleValue,
        whoRequested: this.state.whoRequestedValue,
        cameraView: this.state.cameraViewValue,
        status: this.state.statusValue,
        tabIndex: this.state.tabIndex
      });
    });
  };

  handleStatus = event => {
    this.setState({ localStatusValue: event.target.value });
  };

  handleCameraView = event => {
    this.setState({ localCameraViewValue: event.target.value, });
  }

  handleVehicle = event => {
    this.setState({ localVehicleValue: event.target.value });
  };

  handleWhoRequested = event => {
    this.setState({ localWhoRequestedValue: event.target.value });
  };

  handleOpen = () => {
    setTimeout(() => {
      try {
          const btnEle = document.getElementById('onDemandFiltering');
          if(btnEle && btnEle.getBoundingClientRect() && btnEle.getBoundingClientRect().left){
              let leftPos = btnEle.getBoundingClientRect().left - 112;
              const targetEle = document.getElementsByClassName('onDemandPrev')[0];
              if(targetEle && leftPos > 0 ) {
                  targetEle.style.left = `${leftPos}px`;
              }
              //If the screen resolution is less than 1024, we need to check whether the last dropdown fits within the viewport. If not, then we need to include offset to make it visible. Its temporary fix and need to explore options to handle it in better way in mobile layouts.
              if(!this.isElementInViewport(targetEle) && window.innerWidth < 1024){
                leftPos = leftPos - 180;
                targetEle.style.left = `${leftPos}px`;
              }
          }
      } catch (error) {

      }

    }, 5);
    this.setState({open: true})
  };

  isElementInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleOnFilter = () => {
    const cameraViewArray = this.state.localCameraViewValue.sort((a, b) => a - b);

    this.setState({
      vehicleValue: this.state.localVehicleValue,
      whoRequestedValue: this.state.localWhoRequestedValue,
      cameraViewValue: cameraViewArray,
      statusValue: this.state.localStatusValue
    }, () => {
      let statusValue = this.state.statusValue;
      if (statusValue.includes('requested')) {
        statusValue = this.handleParseRequested(statusValue);
      }

      this.setState({open: false});
      let camera_vals = [];
      cameraViewArray && cameraViewArray.length > 0 && cameraViewArray.forEach((cid) => {
        const channel_item = this.state.defaultCameraViewValue.find((ch) => ch.id == cid);
        channel_item && camera_vals.push(channel_item.channel);
      })
      this.props.onChange({
        vehicle: this.state.vehicleValue,
        whoRequested: this.state.whoRequestedValue,
        cameraView: uniq(camera_vals),
        status: statusValue,
        tabIndex: this.state.tabIndex
      });
    });
  }

  handleParseRequested = value => {
    if (Array.isArray(value)) {
      return value.flatMap(status => {
        if (status === 'requested') {
          return ['created', 'reopened'];
        }

        return status;
      });
    }

    return ['created', 'reopened'];
  }

  renderOption = (option) => {
    let options = [];
    const isChecked = includes(this.state.localStatusValue, option.id);
    options = (
      <MenuItem key={option.id} value={option.id}>
        <Checkbox checked={isChecked} />
        <ListItemText primary={I18n.t(option.name)} />
      </MenuItem>
    );

    return options
  }

  renderStatusValue = value => {
    const getSelectedValue = id => {
      const selected = find(this.state.defaultStatusValue, op => op.id === id);
      if (selected.root) {
        return [];
      }
      return I18n.t(get(selected, 'name', get(selected, 'name')));
    };

    return join(flatMap(value, getSelectedValue), ', ');
  }

  renderOptions = () => {
    return map(this.state.defaultStatusValue, value => this.renderOption(value))
  }

  filterCount() {
    const count = this.state.localCameraViewValue.length +
      this.state.localStatusValue.length +
      (this.state.localVehicleValue ? 1 : 0) +
      (this.state.localWhoRequestedValue ? 1 : 0);

    return count;
  }

  render() {
    return (
      <div className="onDemandFilter">
        <FormControl style={{ maxWidth: "110px" }}>
          <Badge showZero badgeContent={this.filterCount()} className="viappbar__badge-yellow viappbar__badgeposition">
            <Button
              id="onDemandFiltering"
              onClick={this.handleOpen}
              variant="contained"
              style={{
                width: "100px",
                justifyContent: "left",
                textTransform: "capitalize"
              }}
              className="chip__datepickerchip filtertype-label"
            >
              {I18n.t('page.onDemand.previouslyQueue.buttonFilter')}
              <ArrowDropDownIcon
                style={{ color: "white", position: "absolute", right: "5px" }}
              />
            </Button>
          </Badge>
        </FormControl>
        <Dialog
          open={this.state.open}
          onClose={this.handleRequestClose}
          BackdropProps={{
            invisible: true
          }}
          classes={{
            root: 'libraryfilter',
            paper: 'libraryfilter__more onDemandPrev'
          }}
        >
          <div className="filterContainer">
            <div id="vehicleFilter">
              <TextField
                label={I18n.t('page.onDemand.previouslyQueue.fields.vehicle')}
                name="vehicle"
                type="text"
                fullWidth
                value={this.state.localVehicleValue}
                onChange={this.handleVehicle}
              />
            </div>
            <div id="whoRequestedFilter">
              <TextField
                label={I18n.t('page.onDemand.previouslyQueue.fields.whoRequested')}
                name="whoRequested"
                type="text"
                fullWidth
                value={this.state.localWhoRequestedValue}
                onChange={this.handleWhoRequested}
              />
            </div>
            <div id="cameraViewFilter">
              <FormControl fullWidth>
                <InputLabel id="cameraView">{I18n.t('page.onDemand.previouslyQueue.fields.cameraView')}</InputLabel>
                <Select
                  label="cameraView"
                  name="cameraView"
                  multiple
                  value={this.state.localCameraViewValue}
                  onChange={this.handleCameraView}
                  renderValue={(selected) =>
                    selected.map(cid => {
                      const channel_item = this.state.defaultCameraViewValue.find((ch) => ch.id == cid);
                      return channel_item && I18n.t(channel_item.name) || "";
                    }).join(", ")
                  }
                  MenuProps={MenuProps}
                >
                  {this.state.defaultCameraViewValue.map(cview => (
                    <MenuItem key={cview.id} value={cview.id}>
                      <Checkbox checked={this.state.localCameraViewValue.indexOf(cview.id) > -1}
                      />
                      <ListItemText primary={I18n.t(cview.name)} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div id="statusFilter">
              <FormControl fullWidth>
                <InputLabel htmlFor="status">{I18n.t('page.onDemand.previouslyQueue.fields.status')}</InputLabel>
                <Select
                  label="status"
                  name="status"
                  id="status"
                  multiple
                  value={this.state.localStatusValue}
                  onChange={this.handleStatus}
                  renderValue={this.renderStatusValue}
                  MenuProps={MenuProps}
                >
                  {this.renderOptions()}
                </Select>
              </FormControl>
            </div>
            <div id="btnFilter" style={{ marginTop: "30px" }}>
              <Button
                onClick={this.handleClear}
                variant="contained"
                className="btn btn-secondary"
              >
                {I18n.t('action.clear')}
              </Button>
              <Button
                onClick={this.handleOnFilter}
                variant="contained"
                className="btn btn-primary"
              >
                {I18n.t('action.apply')}
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}
